import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CleanTextModalBody from '../../components/modal/bodies/clean-text';
import EndHomeworkModalBody from '../../components/modal/bodies/end-homework';
import NotLoggedModalBody from '../../components/modal/bodies/not-logged';
import PauseModalBody from '../../components/modal/bodies/pause';
import RatingModalBody from '../../components/modal/bodies/rating';
import SendGradeErrorModalBody from '../../components/modal/bodies/send-grade-error';
import ReportModal from '../../components/report/components/modal';
import ResetGeogebraModalBody from '../../components/modal/bodies/reset-geogebra';
import ResumeHomeworkModalBody from '../../components/modal/bodies/resume-homework';
import TheoriesModalBody from '../../components/modal/bodies/theories';
import TimeOutModalBody from '../../components/modal/bodies/time-out';
import ForcedTerminationModalBody from '../../components/modal/bodies/forced-termination';
import GetUserInfoModalBody from '../../components/modal/bodies/get-user-info';

const ModalComponents = {
    CLEAN_TEXT_MODAL: CleanTextModalBody,
    END_HOMEWORK_MODAL: EndHomeworkModalBody,
    NOT_LOGGED_MODAL: NotLoggedModalBody,
    PAUSE_MODAL: PauseModalBody,
    RATING_MODAL: RatingModalBody,
    SEND_GRADE_ERROR_MODAL: SendGradeErrorModalBody,
    REPORT_MODAL: ReportModal,
    RESET_GEOGEBRA_MODAL: ResetGeogebraModalBody,
    RESUME_HOMEWORK_MODAL: ResumeHomeworkModalBody,
    THEORIES_MODAL: TheoriesModalBody,
    TIME_OUT_MODAL: TimeOutModalBody,
    FORCED_TERMINATION_MODAL: ForcedTerminationModalBody,
    GET_USER_INFO_MODAL: GetUserInfoModalBody,
};

export const ModalContainer = ({ modal }) => {
    const SpecificModal = ModalComponents[modal.type];
    return <>{modal.visible && modal.type && <SpecificModal />}</>;
};

const mapStateToProps = (state) => {
    return {
        modal: state.modal,
    };
};

ModalContainer.propTypes = {
    modal: PropTypes.object,
};

export default connect(mapStateToProps)(ModalContainer);
